import { Skeleton } from './utils/Skeleton';
import styles from './LastUpdate.module.scss';

const LastUpdate = ({ postion, dateModify, resultsLoaded }) => {
  return (
    (dateModify || !resultsLoaded) && (
      <div className={postion == 'top' ? styles['last-updated-top'] : styles['last-updated-bottom']}>
        <p className={styles['last-updated']}>Last Updated: {dateModify ? dateModify : <Skeleton />}</p>
      </div>
    )
  );
};

export { LastUpdate };
